import React from 'react';
import {
    Tag,
    Row,
    Space,
    Button,
    Input,
    DatePicker,
    Select,
    Table,
    Pagination,
    Checkbox,
    Modal,
    Upload,
    Transfer,
    Form,
    Col,
    Rate,
    Divider,
    Radio,
    message,
    Popconfirm,
    Alert
} from 'antd';
import {Redirect, Link, withRouter} from 'react-router-dom';
import store from "../store/store.js";
import {DeleteOutlined, UploadOutlined, EditOutlined, PlusOutlined, CloseOutlined} from '@ant-design/icons'
import moment from 'moment';

const {Option, OptGroup} = Select;
const {TextArea} = Input;
const {RangePicker} = DatePicker;

class Edit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            condition: {
                id: props.id,
            },
            visible: false,
            loading: false,
            loading2: false,
        };
        store.subscribe(() => {
            // console.log('state状态改变了，新状态如下')
            // console.log(store.getState().data.isLogin)
        })
    }

    componentDidMount() {


    }

    sub() {
        let that = this
        that.setState({
            loading: true
        })
        let arr = that.state.condition
        arr.dwtype = 1
        fetch('/Buy/doview', {
            method: "POST",
            body: JSON.stringify(arr)
        })
            .then(res => res.json())
            .then(data => {
                if (data.status == 1) {
                    message.success(data.msg);
                    this.props.refresh()
                    this.mdchange()
                } else {
                    message.error(data.msg)
                    that.setState({
                        loading: false
                    })
                }
            })
    }

    mdchange() {
        let that = this
        let visible = !that.state.visible
        that.setState({
            visible
        })
        if (visible) {
            fetch('/Buy/view', {
                method: "POST",
                body: JSON.stringify({
                    id: this.props.id,
                })
            })
                .then(res => res.json())
                .then(data => {
                    that.setState({
                        condition: data.data,
                        cglx_react: data.cglx_react ? data.cglx_react : [],
                        cgfs_react: data.cgfs_react ? data.cgfs_react : [],
                    })
                })
        } else {
            that.setState({
                condition: {
                    id: this.props.id,
                },
                loading: false
            })
        }
    }

    onTimeChange(name, date, dateString) {
        let that = this
        console.log(name, date, dateString)
        let data = Object.assign({}, this.state.condition, {[name]: dateString})
        this.setState({
            condition: data
        })
    }

    onRangeChange(name, dates, dateStrings) {
        console.log(dates, dateStrings)
        let data = Object.assign({}, this.state.condition, {[name + '1']: dateStrings[0], [name + '2']: dateStrings[1]})
        this.setState({
            condition: data
        })
    }

    onSelChange(name, value) {
        let that = this
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onChange(name, e) {
        let that = this
        let value = e.target.value
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    onCheckboxChange(name, e) {
        let that = this
        let value = e.target.checked
        console.log(name, value)
        let data = Object.assign({}, this.state.condition, {[name]: value})
        this.setState({
            condition: data
        })
    }

    arrsel(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Option value={item.id} key={index}>{item.name}</Option>
            )
        }
    }

    arrradio(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Radio value={item.id} key={index}>{item.name}</Radio>
            )
        }
    }

    arrCheckbox(arr) {
        if (arr) {
            return arr.map((item, index) =>
                <Checkbox value={item.id} key={index}>{item.name}</Checkbox>
            )
        }
    }

    editorChange = (editorState) => {
        let data = Object.assign({}, this.state.condition, {editorState: editorState, dwjj: editorState.toHTML()})
        this.setState({
            condition: data
        })
    }

    // 上传图片
    picChange(name, info) {
        // console.log(info)
        if (info.file.status === 'uploading') {
            this.setState({loading2: true});
            return;
        }
        if (info.file.status === 'done') {
            // Get this url from response in real world.
            // console.log(info.file.response)

            var fjlist = this.state.condition[name]
            if (!fjlist) {
                fjlist = []
            }
            if (info.file.response.status == 0) {
                message.error(info.file.response.msg)
                return;
            }
            fjlist = fjlist.concat(info.file.response)
            let data = Object.assign({}, this.state.condition, {[name]: fjlist})
            this.setState({
                condition: data,
                loading2: false,
            })
        }
    };

    delpic(index, name, e) {
        var fjlist = this.state.condition[name]
        fjlist.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {[name]: fjlist})
        this.setState({
            condition: data,
        })
    }

    addjh() {
        let plan = this.state.condition.plan ? this.state.condition.plan.concat() : []
        let newArr = {}
        plan.push(newArr)
        let data = Object.assign({}, this.state.condition, {plan})
        this.setState({
            condition: data
        })
    }

    deljh(index, e) {
        let plan = this.state.condition.plan ? this.state.condition.plan.concat() : []
        plan.splice(index, 1)
        let data = Object.assign({}, this.state.condition, {plan})
        this.setState({
            condition: data,
        })
    }

    onChange2(name, name2, index, e) {
        let value = e.target.value
        let arr = this.state.condition[name2][index]
        let list = this.state.condition[name2]
        let data = Object.assign({}, arr, {[name]: value})
        list[index] = data
        let data2 = Object.assign({}, this.state.condition, {[name2]: list})
        this.setState({
            condition: data2
        })
    }

    onTimeChange2(name, name2, index, date, dateString) {
        let that = this
        let arr = this.state.condition[name2][index]
        let list = this.state.condition[name2]
        let data = Object.assign({}, arr, {[name]: dateString})
        list[index] = data
        let data2 = Object.assign({}, this.state.condition, {[name2]: list})
        this.setState({
            condition: data2
        })
    }

    render() {

        return (
            <>
                {this.props.id ?
                    <a href='javascript:void(0)' onClick={this.mdchange.bind(this)}>编辑</a>
                    :

                    <>
                        <Button type="primary" icon={<PlusOutlined/>}
                                onClick={this.mdchange.bind(this)}>添加合同</Button>
                    </>
                }

                <Modal title="编辑" maskClosable={false} destroyOnClose={true} width={900} visible={this.state.visible}
                       onCancel={this.mdchange.bind(this)} footer={null}>
                    <Form
                        layout="vertical"
                        // labelCol={{ span: 3 }}
                        wrapperCol={{span: 24}}
                        autoComplete="off"
                    >
                        <Row gutter={[20, 0]} justify="start">
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="项目名称"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.name ? this.state.condition.name : null}
                                           onChange={this.onChange.bind(this, 'name')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="采购项目类型"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.cglx ? this.state.condition.cglx : []}
                                        onChange={this.onSelChange.bind(this, 'cglx')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.cglx_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="采购方式"
                                    required={true}
                                >
                                    <Select
                                        // mode="multiple"
                                        allowClear
                                        style={{width: '100%'}}
                                        placeholder="请选择"
                                        value={this.state.condition.cgfs ? this.state.condition.cgfs : []}
                                        onChange={this.onSelChange.bind(this, 'cgfs')}
                                        maxTagCount="responsive"
                                        showSearch
                                        optionFilterProp="children"
                                    >
                                        {this.arrsel(this.state.cgfs_react)}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="中标单位"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.company ? this.state.condition.company : null}
                                           onChange={this.onChange.bind(this, 'company')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="合同编号"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.ref ? this.state.condition.ref : null}
                                           onChange={this.onChange.bind(this, 'ref')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="合同签订时间"
                                    required={true}
                                >
                                    <DatePicker className="input" placeholder="请选择"
                                                onChange={this.onTimeChange.bind(this, 'qdtime')}
                                                value={this.state.condition.qdtime ? moment(this.state.condition.qdtime) : null}
                                                style={{width: "100%"}}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="合同金额"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.amount ? this.state.condition.amount : null}
                                           onChange={this.onChange.bind(this, 'amount')}
                                           suffix={'元'}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="服务期限"
                                    required={true}
                                >
                                    <RangePicker style={{width: '100%'}} allowEmpty={[true, true]}
                                                 onChange={this.onRangeChange.bind(this, 'time')}
                                                 value={[(this.state.condition.time1 ? moment(this.state.condition.time1) : null), (this.state.condition.time2 ? moment(this.state.condition.time2) : null)]}
                                                 placeholder={['请输入', '请输入']}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="付款方式"
                                    required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.fkfs ? this.state.condition.fkfs : null}
                                           onChange={this.onChange.bind(this, 'fkfs')}
                                    />
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="我方对接人"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.wf_djr ? this.state.condition.wf_djr : null}
                                           onChange={this.onChange.bind(this, 'wf_djr')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="对方联系人"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.df_lxr ? this.state.condition.df_lxr : null}
                                           onChange={this.onChange.bind(this, 'df_lxr')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <Form.Item
                                    label="联系人电话"
                                    // required={true}
                                >
                                    <Input placeholder="请输入"
                                           value={this.state.condition.df_phone ? this.state.condition.df_phone : null}
                                           onChange={this.onChange.bind(this, 'df_phone')}/>
                                </Form.Item>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item
                                    label="合同附件"
                                    required={true}
                                >
                                    <Row justify="space-between">
                                        <Space align="center">
                                            <Upload
                                                showUploadList={false}
                                                action="/Ajax/upload"
                                                onChange={this.picChange.bind(this, 'fjlist')}
                                                multiple={true}
                                                data={{
                                                    pc: 1
                                                }}
                                            >
                                                <Button icon={<UploadOutlined/>}>上传</Button>
                                            </Upload>
                                            <Space wrap>
                                                {this.state.condition.fjlist ? this.state.condition.fjlist.map((item, index) =>
                                                    <div>
                                                        <a href={item.url} target="_blank">{item.name} </a>
                                                        <DeleteOutlined className="hongse"
                                                                        onClick={this.delpic.bind(this, index, 'fjlist')}/>
                                                    </div>) : null}

                                            </Space>
                                        </Space>
                                    </Row>
                                </Form.Item>
                            </Col>
                            <Col span={24}>
                                <Divider>支付计划</Divider>
                            </Col>
                            {this.state.condition.plan ? this.state.condition.plan.map((item, index) =>
                                <>
                                    <Col className="gutter-row" span={6}>
                                        <Form.Item
                                            label="支付时间"
                                        >
                                            <DatePicker className="input" placeholder="请选择"
                                                        onChange={this.onTimeChange2.bind(this, 'dateline', 'plan', index)}
                                                        value={item.dateline ? moment(item.dateline) : null}
                                                        style={{width: "100%"}}
                                            />
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={6}>
                                        <Form.Item
                                            label="金额"
                                        >
                                            <Input placeholder="请输入" value={item.num ? item.num : null}
                                                   onChange={this.onChange2.bind(this, 'num', 'plan', index)}
                                                   suffix={'元'}/>
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={11}>
                                        <Form.Item
                                            label="备注"
                                        >
                                            <Input placeholder="请输入" value={item.remark ? item.remark : null}
                                                   onChange={this.onChange2.bind(this, 'remark', 'plan', index)}/>
                                        </Form.Item>
                                    </Col>
                                    <Col className="gutter-row" span={1}>
                                        <Form.Item
                                            label=" "
                                        >
                                            <Popconfirm
                                                title="确认删除?"
                                                onConfirm={this.deljh.bind(this, index)}
                                                onCancel={() => {
                                                }}
                                                okText="确定"
                                                cancelText="取消"
                                            >
                                                <a><CloseOutlined style={{color: '#aaa', fontSize: 16}}/></a>
                                            </Popconfirm>
                                        </Form.Item>

                                    </Col>
                                </>
                            ) : null}
                            <Col className="gutter-row" span={24}>
                                <a onClick={this.addjh.bind(this)}>+添加</a>
                            </Col>
                            <Col className="gutter-row" span={24}>
                                <Form.Item>
                                    <Row justify={"center"}>
                                        <Button type='primary' onClick={this.sub.bind(this)}
                                                loading={this.state.loading}>提交</Button>
                                    </Row>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Modal>
            </>
        )
    }
}

export default Edit
